export default "__VITE_ASSET__DlOP9oXL__"